// extracted by mini-css-extract-plugin
export default {"icon":"GIcon-module_icon_a8ec2ccc","iconBorder":"GIcon-module_iconBorder_a3fc862d","iconCircle":"GIcon-module_iconCircle_f719e37c","iconSquare":"GIcon-module_iconSquare_f3412d63"};